module.exports = __webpack_public_path__ + "static/media/peppermint.a43b35de.webp";